import * as React from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { ISessionState } from "../../models/session/sessionState";

interface IPrivateRouteProps extends RouteProps {
    // tslint:disable-next-line:no-any
    sessionState: ISessionState;
    component: any;
}

interface IPrivateRouteState {
    canUseSystem: boolean;
}

export class PrivateRoute extends React.Component<IPrivateRouteProps, IPrivateRouteState> {
    constructor(props) {
        super(props);
        this.state = { canUseSystem: props.sessionState.canUseSystem() || props.sessionState.canExternalSystems() };
    }

    render() {
        const { component: Component, ...rest } = this.props;
        const state = this.state;
        return (
            <Route {...rest} render={props => {
                return state.canUseSystem
                    ? <Component {...props} />
                    : <Redirect to={{ pathname: "/login", state: { from: props.location } }} />;
            }} />
        );
    }
}